export const PANEL_ID = {
  ai: "ai",
  legend: "legend",
  viewOptions: "view-options",
  metrics: "metrics",
  properties: "properties",
  details: "details",
};

export const ORG_CHART_PANEL_EVENTS = {
  EDIT_TEAM_DETAILS: "edit-team-details",
  SET_SELECTED_PANEL: "FloatingPanels_SetSelectedPanel",
  SELECTED_PANEL_CHANGED: "FloatingPanels_SelectedPanelChanged",
};
